const firstOrUndefined = <T>(items?: T[]): T | undefined => {
  if (!items || items.length < 1) {
    return undefined;
  }
  return items[0];
};

export default firstOrUndefined;
